import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-payout',
    templateUrl: './payout.component.html',
    styleUrls: ['./payout.component.scss'],
    standalone: false
})
export class PayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
